export const getDocumentHeight = () => {
	var rootApp = $('#root-app');
	var marginBottom = 20;

	return rootApp.height() + marginBottom;
};

export const getMobileDetect = () => {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	if (/android/i.test(userAgent))
		return "Android";

	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
		return "iOS";

	return "unknown";
}

export default {
	getDocumentHeight,
	getMobileDetect
};
